// extracted by mini-css-extract-plugin
module.exports = {"header_info":"header_info-4be0a342","info_wrapper":"info_wrapper-b6d8ebf5"};